import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import { Info } from "lucide-react";
import {
  APP_VERSION,
  APP_BUILD_DATE,
  APP_DEVELOPER,
  APP_COMPANY,
  APP_DEVELOPER_LOGO,
  APP_COMPANY_DESCRIPTION,
  APP_CLIENT_COMPANY,
  APP_SUPPORT_EMAIL,
} from "../appInfo";

export const AboutAppDialog = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[88vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Info className="w-5 h-5 text-slate-700" />
            Sobre o App
          </DialogTitle>
          <DialogDescription>
            Informações técnicas, sobre o desenvolvedor e legais do aplicativo.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 text-sm">
          {/* Technical info */}
          <dl className="space-y-1.5 text-xs">
            <div className="flex items-center justify-between">
              <dt className="text-slate-500">Versão</dt>
              <dd className="font-mono text-slate-900">{APP_VERSION}</dd>
            </div>
            <div className="flex items-center justify-between">
              <dt className="text-slate-500">Build</dt>
              <dd className="font-mono text-slate-900">{APP_BUILD_DATE}</dd>
            </div>
            <div className="flex items-center justify-between">
              <dt className="text-slate-500">Desenvolvedor</dt>
              <dd className="text-slate-900 font-medium">{APP_DEVELOPER}</dd>
            </div>
            <div className="flex items-center justify-between">
              <dt className="text-slate-500">Empresa</dt>
              <dd className="text-slate-900 font-medium">{APP_COMPANY}</dd>
            </div>
            <div className="flex items-center justify-between">
              <dt className="text-slate-500">Cliente</dt>
              <dd className="text-slate-900">{APP_CLIENT_COMPANY}</dd>
            </div>
            <div className="flex items-center justify-between">
              <dt className="text-slate-500">Suporte (RH)</dt>
              <dd className="text-slate-900">{APP_SUPPORT_EMAIL}</dd>
            </div>
          </dl>

          {/* Developer block: logo + description */}
          <div className="rounded-lg bg-gradient-to-b from-slate-900 to-black border border-slate-800 p-4 space-y-3">
            <div className="flex justify-center">
              <img
                src={APP_DEVELOPER_LOGO}
                alt="Dark Horse Tecnologia"
                className="h-28 w-auto object-contain"
                data-testid="about-app-developer-logo"
              />
            </div>
            <p
              className="text-[11px] text-slate-300 leading-relaxed whitespace-pre-line text-justify"
              data-testid="about-app-company-description"
            >
              {APP_COMPANY_DESCRIPTION}
            </p>
          </div>

          {/* LGPD note */}
          <div className="text-[10px] text-slate-500 leading-relaxed pt-2 border-t border-slate-100">
            Este aplicativo cumpre a LGPD (Lei 13.709/2018). Os dados são
            tratados estritamente para fins trabalhistas e de comunicação
            interna. Assinaturas digitais seguem o padrão ICP-Brasil
            (MP 2.200-2/2001).
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AboutAppDialog;
